module.exports = __webpack_public_path__ + "fonts/F37GingerPro-Regular.4847fda.woff2";